module.exports = __webpack_public_path__ + "media/admin/components/activities/live/agenda/contact-card/person-image-29fabf84de863105f33216f58e6aa6e2.jpg";